import _ from 'underscore';

import { DEFAULT_GEO_LOCATION } from './utils';

/**
 * Represents an instance of a Bing Maps V8 Web Control.
 * See: https://docs.microsoft.com/en-us/bingmaps/v8-web-control/
 */
export class BingMap {
  constructor({
    bingMapsApiKey,
    element,
    Maps,
    onGetTooltipHtmlContent,
  }) {
    this.Maps = Maps;
    this.center = new Maps.Location(
      DEFAULT_GEO_LOCATION.latitude,
      DEFAULT_GEO_LOCATION.longitude
    );
    const mapOptions = {
      center: this.center,
      credentials: bingMapsApiKey,
      enableSearchLogo: false,
      mapTypeId: Maps.MapTypeId.road,
      navigationBarMode: Maps.NavigationBarMode.compact,
      restrictKeyboardListeningToMapContainer: true,
      showBreadcrumb: false,
      showDashboard: true,
      showLocateMeButton: false,
      showMapTypeSelector: false,
      showScalebar: true,
      zoom: 11,
    };

    this.polygonLayer = new Maps.Layer({ zIndex: 100 });
    this.pushpinLayer = new Maps.Layer({ zIndex: 200 });

    // Create Bing Map and render inside the element
    this.map = Maps.Map(element, mapOptions);
    // Add layers to map
    this.map.layers.insertAll([this.polygonLayer, this.pushpinLayer]);

    this.onGetTooltipHtmlContent = onGetTooltipHtmlContent;
    // TODO: support customized infobox
    if (_.isFunction(this.onGetTooltipHtmlContent)) {
      this.tooltip = new Maps.Infobox(
        new Maps.Location(0, 0),
        {
          showPointer: true,
          showCloseButton: false,
          visible: false,
        }
      );
      // Assign the infobox to a map instance.
      this.tooltip.setMap(this.map);
    }
  }

  addPushpinToCenter(point, { eventType, handler } = {}) {
    this.center = new this.Maps.Location(point.latitude, point.longitude);

    this.map.setView({
      center: this.center,
      zoom: 13,
    });

    const pushpin = new this.Maps.Pushpin(this.center);

    if (eventType && handler) {
      this.Maps.Events.addHandler(pushpin, eventType, handler);
    }

    // Clear all existing pushpins
    for (let i = this.map.entities.getLength() - 1; i >= 0; i -= 1) {
      const entity = this.map.entities.get(i);
      if (entity instanceof this.Maps.Pushpin) {
        this.map.entities.removeAt(i);
      }
    }

    // Add the pushpin to the map
    this.map.entities.push(pushpin);
  }
}
